import axios from "axios";

const api = axios.create({
  baseURL: "https://hrgo-job-board-api.azurewebsites.net",
});

const createFormData = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return formData;
};

export const getLatestJobs = (latitude, longitude, distance = 20) => {
  return api.get(
    `/jobs?items=6&sortBy=dateCreated&primaryWebsiteId=4BcH6qS1HmVq3WoEsnFEu3&activeOnly=true&latitude=${latitude}&longitude=${longitude}&distance=${distance}`
  );
};

export default async ({ jobId, cvUrl, fullName, email, telephone }) => {
  const formData = createFormData({
    cloudCvSharedLink: cvUrl,
    applicantName: fullName,
    applicantEmail: email,
    applicantTelephone: telephone,
    marketingContent: false,
  });
  return api.post(`/jobApplicationsWithSharedLink/${jobId}`, formData);
};
